import React, { createElement } from 'react'
import classNames from 'classnames'
import { useTheme } from '@emotion/react'

export default function Container(props = {}){
    const theme = useTheme()
    const MAX_WIDTH = theme.breakpoints.xl

    const {
        type = 'div',
        id,
        className,
        style,
        fluid,
        maxWidth,
        children,
    } = props

    const myprops = {
        id,
        className: classNames(
            'container',
            { 'fluid': fluid },
            'w-100',
            'mx-auto',
            className,
        ),
        style: {
            ...style,
            maxWidth: maxWidth ? maxWidth :
                fluid ? '100%' :
                MAX_WIDTH
        }
    }

    return createElement(type, myprops, children)
}
